import { SseDocument } from './sse-document';

export function isDocument(
  response: SseDocument | object | undefined
): response is SseDocument {
  return !!(
    response &&
    'name' in response &&
    'path' in response &&
    'mimeType' in response &&
    typeof response.path === 'string' &&
    typeof response.name === 'string' &&
    typeof response.mimeType === 'string'
  );
}
